/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Chat from "layouts/chat";
// import Tables from "layouts/tables";
// import Billing from "layouts/billing";
// import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
// import SignIn from "layouts/authentication/sign-in";
import Login from "./pages/authentication/login";
import Organization from "./pages/organization";
import Keys from "./pages/keys";
import Users from "./pages/users";
import Cookies from "js-cookie";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import ProtectedRoute from "./routes/protectedroute"; // Adjust path as necessary

const userData = Cookies.get("user");
const user = userData ? JSON.parse(userData) : null;
const userRole = user?.Roles[0].name || "guest"; // Default role if not logged in


const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute component={Dashboard} />,
    allowedRoles: ["admin", "user"], // Allow these roles
  },
  {
    type: "collapse",
    name: "Chat",
    key: "chats",
    icon: <Icon fontSize="small">sms</Icon>,
    route: "/chats",
    component: <ProtectedRoute component={Chat} />,
    allowedRoles: ["admin","user"], // Allow these roles
  },
  {
    type: "collapse",
    name: "Organizations",
    key: "organizations",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/Organizations",
    component: <ProtectedRoute component={Organization} />,
    allowedRoles: ["admin"], // Allow these roles
  },
  {
    type: "collapse",
    name: "Keys",
    key: "keys",
    icon: <Icon fontSize="small">key</Icon>,
    route: "/keys",
    component: <ProtectedRoute component={Keys} />,
    allowedRoles: ["admin"], // Allow these roles
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/users",
    component: <ProtectedRoute component={Users} />,
    allowedRoles: ["admin"], // Allow these roles
  },
  // {
  //   type: "none",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "none",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "none",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "none",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "none",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "none",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <Login />,
  },
  {
    type: "none",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
];


let allowedRouteKeys = routes
  .filter(route => route.allowedRoles && route.allowedRoles.includes(userRole));

if (allowedRouteKeys.length === 0) {
  allowedRouteKeys = routes;
}

export default allowedRouteKeys;
